import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { FeatureGatedColumnMeta } from '.'
import { CellAction } from './CellAction'
import { columnHelper } from './columnHelper'
import { Unavailable } from './MissingData'

const key = IdentificationUrlKeys.HighRecallId
const label = 'highRecallId'

export const highRecallIdColumn = (meta?: FeatureGatedColumnMeta) =>
  columnHelper.display({
    id: 'highRecallId',
    header: 'High Recall ID',
    meta,
    cell: ({ row }) => {
      const highRecallId = row.original.supplementary_id_high_recall?.visitor_id

      if (!highRecallId) {
        return <Unavailable />
      }

      return (
        <CellAction copyValue={highRecallId} search={(old) => ({ ...old, [key]: highRecallId })} field={label}>
          <Typography className='font-mono'>{highRecallId}</Typography>
        </CellAction>
      )
    },
  })
